import { render } from "./column.vue?vue&type=template&id=07d935d0"
import script from "./column.vue?vue&type=script&lang=js"
export * from "./column.vue?vue&type=script&lang=js"

import "./column.vue?vue&type=style&index=0&id=07d935d0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-content/column.vue'],['render',render],['__file',"column.vue"]])

export default __exports__